import { observer } from 'mobx-react';
import React from 'react';
import PropTypes from 'prop-types';
import './icon.css';
import classnames from 'classnames';

export const Icon = observer((props) => {
  const { icon, name, children, className, size, ...rest } = props;
  const cl = {
    'ms-icon': 1,
    'material-icons': 1,
    'notranslate': 1,
    'ms-icon--button': rest.onClick != null,
    [className]: !!className,
  };
  if (size) cl['ms-icon--' + size] = 1;
  return (
    <span className={classnames(cl)} {...rest}>{icon || name || children}</span>
  );
});

Icon.propTypes = {
  icon: PropTypes.string,
};

Icon.defaultProps = {
  icon: '',
};
